module.exports = __webpack_public_path__ + "img/SOWTA_Original_1k.4fda1423.png";